import {PublishToTeachersNumerable} from '@esgi/main/features/admins/subject-management';

type Parameters = {
	isPublishForAllTeachers: boolean;
};

export function getPublishForTeachersSaveData({isPublishForAllTeachers}: Parameters): PublishToTeachersNumerable {
	return isPublishForAllTeachers ? PublishToTeachersNumerable.All : PublishToTeachersNumerable.None;
}
